module.exports = __webpack_public_path__ + "81be27e2f85b5019d048b4caba26fd46.svg";